import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ProjectsService} from '../_services/projects.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SingleProjectModel} from '../_models/singleProject.model';
import {TeamMember} from '../_models/teamMember.model';
import {Note} from '../_models/note.model';
import {ProjectStage} from '../_models/projectStage.model';
import {Attachment} from '../_models/attachments.model';
import {Events, Item, NgxTimeSchedulerService, Period, Section} from 'ngx-time-scheduler';
import * as moment from 'moment';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {DataTableDirective} from 'angular-datatables';

@Component({
    selector: 'app-project-view',
    templateUrl: './project-view.component.html',
    styleUrls: ['./project-view.component.scss']
})
export class ProjectViewComponent implements OnInit, OnDestroy, AfterViewInit {
    dataLoaded: boolean;
    projectId: string;
    projectData: SingleProjectModel;
    teamIds = [];
    allTeam: any;
    teamMembers: TeamMember[] = [];
    projectNotes: Note[] = [];
    projectStage: ProjectStage[] = [];
    projectFiles: Attachment[] = [];

    // allowed to see removed tasks
    viewRemovedTasks = false;
    removedTasks = [];

    // pastram o referinta catre removed/current tasks ca sa facem switch intre ele
    selectedTasks = [];
    // Tasks List
    listName: string;
    selectedList: string;

    // array of current user roles
    userRoles = [];
    currentUserId: string;

    // Tasks
    @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
    tasks: any = [];
    dtTrigger: Subject<any> = new Subject();
    dtOptions: any = {};
    // stage-uri pt filtru la tabel
    stages = ['None'];
    hideFilters = true;

    // Feedback Messages
    formResponse: boolean;
    formSent: boolean;
    successMsg = '';
    errorMsg = '';

    // progress bar by date
    progressBar = 0;
    barClass: string;
    spanColor: string;

    completionLoaded = false;
    projectCompletion = 1;

    // gantt chart
    events: Events = new Events();
    periods: Period[];
    sections: Section[];
    items: Item[] = [];
    startDate: any;
    originalItems = [];
    otherItemId: number;
    selectedItem: string;
    stagesExist = false;

    chartOptions: any = {};

    // New Task Form
    newTaskForm: FormGroup;
    subTasks = [];

    // User Permissions
    isAllowedToEdit = false;
    isAllowedToView = false;

    // used for disabling the add stage button while waiting for server response
    isDisabled = false;

    newStageForm: FormGroup;
    colorsClasses = ['stage-red', 'stage-blue', 'stage-yellow', 'stage-green', 'stage-orange'];

    // subscriptions
    unsubscribe = [];

    constructor(private projectsService: ProjectsService,
                private route: ActivatedRoute,
                private router: Router,
                private ganttService: NgxTimeSchedulerService,
                private modalService: NgbModal,
                private fb: FormBuilder) {
    }

    ngOnInit(): void {
        this.getCurrentUser();
        this.getProjectById();

        this.dtOptions = {
            columnDefs: [{
                targets: 5,
                orderable: false
            }, {
                className: 'dtr-control',
                orderable: false,
                targets: -1
            }, {
                width: '1%',
                targets: [0, -1]
            }, {
                targets: 2,
                render: (data, type) => {
                    const dateDisplay = data.split('/').reverse().join('/');
                    return type === 'display' || type === 'filter' ? dateDisplay : data;
                }
            }, {
                targets: 1,
                responsivePriority: 1
            }],
            initComplete: (settings, json) => {
                $('#myTable').show();
                $('#mySpinner').hide();
            },
            autoWidth: false,
            responsive: {
                details: {
                    type: 'column',
                    target: -1,
                    renderer: $.fn.dataTable['Responsive'].renderer.listHiddenNodes()
                }
            },
            dom: '<<t>pl>',
            order: [[0, 'desc']]
        };

        this.loadStageForm();
        this.getUserSubUsers();
    }

    checkForPermissions(moduleName: string, rolesArray: string[]) {
        if (rolesArray.includes('ROLE_super_admin') || rolesArray.includes('ROLE_admin')) {
            this.isAllowedToEdit = true;
            this.isAllowedToView = true;
            
        } else {
            if (rolesArray.includes(`ROLE_${moduleName}Full`)) {
                this.isAllowedToEdit = true;
                this.isAllowedToView = true;
                
            } else if (rolesArray.includes(`ROLE_${moduleName}View`)) {
                this.isAllowedToEdit = false;
                this.isAllowedToView = true;
                
            }
        }
    }


    getCurrentUser() {
        const sub = this.projectsService.getCurrentUser().subscribe((user: any) => {
            this.currentUserId = user.id;
            this.userRoles = user.roles;
            if (this.userRoles !== null) {
                if (this.userRoles.includes('ROLE_super_admin') || this.userRoles.includes('ROLE_admin')) {
                    this.viewRemovedTasks = true;
                }
            }
            this.checkForPermissions('Projects', this.userRoles);
        });
        this.unsubscribe.push(sub);
    }

    loadTaskForm() {
        const today = new Date().toISOString().split('T')[0];
        let resMember;
        if (this.teamMembers && this.teamMembers[0] && this.teamMembers[0].id) {
            resMember = this.teamMembers[0].id;
        } else {
            resMember = '';
        }
        this.newTaskForm = this.fb.group({
            name: [null, Validators.required],
            stage: [0],
            description: [null],
            responsible: [resMember],
            dueDate: [today, Validators.required]
        });
        this.subTasks = [];
    }

    submitTaskForm() {
        
        
        this.newTaskForm.markAllAsTouched();
        if (this.newTaskForm.valid) {
            const today = new Date().toISOString().split('T')[0];

            const taskToSend = {
                messageTitle: this.newTaskForm.value.name,
                messageDetail: this.newTaskForm.value.description,
                receiverUserId: this.newTaskForm.value.responsible,
                deadline: this.newTaskForm.value.dueDate + 'T09:18:19.108Z',
                subtasks: this.subTasks,
                senderUserId: this.currentUserId,
                id: 'string',
                labelTask: 'string',
                attachments: [{
                    name: 'string',
                    link: 'string'
                }],
                additionDate: today + 'T09:18:19.108Z',
                status: 'new',
                labelColour: 'string',
                projectId: this.projectId,
                projectStage: this.newTaskForm.value.stage,
                taskMessages: [{
                    message: 'string',
                    messageDate: '2022-03-25T09:18:19.108Z',
                    userId: 'string'
                }]
            };

            

            if (this.newTaskForm.value.stage !== 0) {
                this.projectsService.createTaskERP(this.projectId, this.newTaskForm.value.stage, taskToSend).subscribe((res: any) => {
                    
                    this.projectsService.getTaskById(res.reason).subscribe(nextRes => {
                        this.tasks.push(nextRes);
                        if (this.selectedList === 'Current Tasks') {
                            this.rerender();
                        }
                        this.modalService.dismissAll();
                    });
                }, error => {
                    
                    this.feedbackMsg('error', 'Something went wrong');
                });
            } else {
                
                this.projectsService.createTaskERPNoStage(this.projectId, taskToSend).subscribe((res: any) => {
                    
                    this.projectsService.getTaskById(res.reason).subscribe(nextRes => {
                        this.tasks.push(nextRes);
                        if (this.selectedList === 'Current Tasks') {
                            this.rerender();
                        }
                        this.modalService.dismissAll();
                    });
                }, error => {
                    
                    this.feedbackMsg('error', 'Something went wrong');
                });
            }

        } else {
            this.feedbackMsg('error', 'Please fill out the required fields');
        }
    }

    pushSubTask(value: string) {
        if (value !== null && value !== '') {
            this.subTasks.push({
                description: value,
                solved: false
            });
        }
    }

    removeSubTask(index) {
        this.subTasks.splice(index, 1);
    }


    getUserSubUsers() {
        const sub = this.projectsService.getTeamMembers(true, false).subscribe(res => {
            
            this.allTeam = res;
        });

        this.unsubscribe.push(sub);
    }

    getProjectsTasks() {
        const sub = this.projectsService.getAllProjectTasks(this.projectId).subscribe((allTasks: any) => {
            this.selectedList = 'Current Tasks';
            this.listName = 'Archived Tasks';
            
            allTasks.forEach(resTask => {
                if (resTask.status !== 'removed') {
                    this.tasks.push(resTask);
                } else {
                    this.removedTasks.push(resTask);
                }
            });
            this.selectedTasks = this.tasks;
            this.dtTrigger.next();
        });
        this.unsubscribe.push(sub);
    }

    changeList() {
        $('#myTable').hide();
        $('#mySpinner').show();
        if (this.listName === 'Archived Tasks') {
            this.listName = 'Current Tasks';
            this.selectedList = 'Archived Tasks';
            this.selectedTasks = this.removedTasks;
            this.rerender();
        } else if (this.listName === 'Current Tasks') {
            this.listName = 'Archived Tasks';
            this.selectedList = 'Current Tasks';
            this.selectedTasks = this.tasks;
            this.rerender();
        }
    }

    openRemoveTaskModal(modal) {
        this.modalService.open(modal, {centered: true});
    }

    removeTask(taskIndex, taskId) {
        
        this.projectsService.changeTaskERPStatus(taskId, 'removed').subscribe(res => {
            const removedTask = {...this.tasks[taskIndex], status: 'removed'};
            this.tasks.splice(taskIndex, 1);
            this.removedTasks.push(removedTask);
            this.rerender();
        });
    }

    rerender(): void {
        this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();

        });
    }

    // Custom validator
    checkDateDifference(control: AbstractControl): ValidatorFn {

        // Set form value in variables
        const startDate = control.get('startDate').value;
        const endDate = control.get('endDate').value;

        // If Start Date is bigger then End Date, then throw error
        if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
            control.get('startDate').setErrors({startDateIsBiggerThanEndDate: true});
        } else {
            if (startDate === undefined || startDate === null || startDate === '') {
                control.get('startDate').setErrors({isEmpty: true});
            } else {
                control.get('startDate').setErrors(null);
            }
        }
        return;
    }

    loadStageForm() {
        const today = new Date().toISOString().split('T')[0];
        
        this.newStageForm = this.fb.group({
            name: [null, Validators.required],
            color: [this.colorsClasses[0]],
            startDate: [today, Validators.required],
            endDate: [today, Validators.required],
            description: [null]
        }, {validators: this.checkDateDifference});
    }


    loadGanttChart() {
        this.events.SectionClickEvent = (section) => {
            
        };
        this.events.ItemClicked = (item) => {
            this.router.navigate(['stage/' + item.sectionID.toString() + '/view'], {relativeTo: this.route});
        };
        this.events.ItemContextMenu = (item: Item, event: MouseEvent) => {
            event.preventDefault();
            const elem = document.querySelector('#contextContainer');
            const offset = elem.getBoundingClientRect();
            const tempX = event.pageX - offset.left;
            const tempY = event.clientY - offset.y + 70;
            this.selectedItem = item.name;
            $('#contextMenu').css({top: tempY, left: tempX, display: 'block'});
        };
        this.events.ItemDropped = (item) => {
            
            

            const prev = this.originalItems[item.id - 1].sectionID;
            const current = item.sectionID;
            let nrItems = 0;
            let otherItemOnly = false;
            this.items.forEach(stage => {
                if (stage.sectionID === current) {
                    nrItems++;
                    if (!otherItemOnly && item.id !== stage.id) {
                        otherItemOnly = true;
                        this.otherItemId = stage.id;
                    }
                }
            });
            
            if (nrItems === 1) {
                this.originalItems[item.id - 1].sectionID = item.sectionID;
                this.changeSections(prev, current);
                this.ganttService.refresh();
            } else {
                if (item.sectionID < prev) {
                    this.changeSections(prev, current);
                    this.items.forEach(it => {
                        if (it.sectionID >= item.sectionID && it.id !== item.id && it.sectionID < prev) {
                            it.sectionID = it.sectionID + 1;
                            this.originalItems[it.id - 1].sectionID = it.sectionID;
                        } else if (it.id === item.id) {
                            this.originalItems[it.id - 1].sectionID = it.sectionID;
                        }
                    });
                } else if (item.sectionID > prev) {
                    this.changeSections(prev, current);
                    this.items.forEach(it => {
                        if (it.sectionID <= item.sectionID && it.id !== item.id && it.sectionID > prev) {
                            it.sectionID = it.sectionID - 1;
                            this.originalItems[it.id - 1].sectionID = it.sectionID;
                        } else if (it.id === item.id) {
                            this.originalItems[it.id - 1].sectionID = it.sectionID;
                        }
                    });
                }
                this.ganttService.refresh();
            }

            // functie de update pt pozitia stagiilor
            this.updateStagePosition();
        };

        this.periods = [
            {
                name: '3 days',
                timeFramePeriod: (60 * 3),
                timeFrameOverall: (60 * 24 * 3),
                timeFrameHeaders: [
                    'Do MMM',
                    'HH'
                ],
                classes: 'period-3day'
            }, {
                name: '1 week',
                timeFrameHeaders: ['MMM YYYY', 'DD(ddd)'],
                classes: '',
                timeFrameOverall: 1440 * 7,
                timeFramePeriod: 1440,
            }, {
                name: '4 week',
                timeFrameHeaders: ['MMM YYYY', 'DD'],
                classes: '',
                timeFrameOverall: 1440 * 28,
                timeFramePeriod: 1440,
            }];

        this.sections = [];
        this.items = [];
        this.originalItems = [];

        this.projectStage.forEach(stage => {
            
            const start = new Date(stage.startDate);
            const end = new Date(stage.deadLine);
            this.sections.push({
                name: stage.name,
                id: this.items.length + 1
            });
            this.originalItems.push({
                id: this.items.length + 1,
                sectionID: Number(stage.position),
                name: stage.name,
                start: moment([start.getFullYear(), start.getMonth(), start.getDate()]).startOf('day'),
                end: moment([end.getFullYear(), end.getMonth(), end.getDate()]).endOf('day'),
                classes: stage.color
            });
            this.items.push({
                id: this.items.length + 1,
                sectionID: Number(stage.position),
                name: stage.name,
                start: moment([start.getFullYear(), start.getMonth(), start.getDate()]).startOf('day'),
                end: moment([end.getFullYear(), end.getMonth(), end.getDate()]).endOf('day'),
                classes: stage.color
            });
        });
    }

    // request de update project la drag and drop
    updateStagePosition() {
        const newStages = [];
        this.items.forEach(newItem => {
            newStages.push({
                name: newItem.name,
                position: newItem.sectionID,
                startDate: this.projectData.stage[newItem.id - 1].startDate,
                deadLine: this.projectData.stage[newItem.id - 1].deadLine,
                duration: this.projectData.stage[newItem.id - 1].duration,
                necessaryResource: this.projectData.stage[newItem.id - 1].necessaryResource,
                status: this.projectData.stage[newItem.id - 1].status,
                observation: this.projectData.stage[newItem.id - 1].observation,
                color: newItem.classes.toString(),
                stageTasks: this.projectData.stage[newItem.id - 1].stageTasks,
                responsible: this.projectData.stage[newItem.id - 1].responsible
            });
        });

        newStages.sort((a, b) => a.position - b.position);
        const sub = this.projectsService.changeProjectStages(this.projectId, newStages).subscribe(res => {
            
        }, error => {
            
        });
        this.unsubscribe.push(sub);
    }

    changeSections(previousId, currentId) {
        const auxName = this.sections[previousId - 1].name;
        if (previousId < currentId) {
            // permutare la stanga
            for (let i = previousId; i < currentId; i++) {
                this.sections[i - 1].name = this.sections[i].name;
            }
            this.sections[currentId - 1].name = auxName;
        } else if (previousId > currentId) {
            // permutare la dreapta
            for (let i = previousId; i > currentId; i--) {
                this.sections[i - 1].name = this.sections[i - 2].name;
            }
            this.sections[currentId - 1].name = auxName;
        }
    }

    addItem() {
        this.isDisabled = true;
        const itemsLength = this.items.length;
        const start = new Date(this.newStageForm.value.startDate);
        const end = new Date(this.newStageForm.value.endDate);
        const newSection = {
            name: this.newStageForm.value.name,
            id: itemsLength + 1
        };
        const newStage = {
            id: itemsLength + 1,
            sectionID: itemsLength + 1,
            name: this.newStageForm.value.name,
            start: moment([start.getFullYear(), start.getMonth(), start.getDate()]).startOf('day'),
            end: moment([end.getFullYear(), end.getMonth(), end.getDate()]).endOf('day'),
            classes: this.newStageForm.value.color.toString()
        };
        const newOriginalStage = {
            id: itemsLength + 1,
            sectionID: itemsLength + 1,
            name: this.newStageForm.value.name,
            start: moment([start.getFullYear(), start.getMonth(), start.getDate()]).startOf('day'),
            end: moment([end.getFullYear(), end.getMonth(), end.getDate()]).endOf('day'),
            classes: this.newStageForm.value.color.toString()
        };

        const stageToSend: any = {
            name: this.newStageForm.value.name,
            position: itemsLength + 1,
            startDate: this.newStageForm.value.startDate,
            deadLine: this.newStageForm.value.endDate,
            duration: 0,
            necessaryResource: '',
            status: '',
            observation: this.newStageForm.value.description,
            color: this.newStageForm.value.color.toString(),
            stageTasks: [],
            responsible: []
        };

        const sub = this.projectsService.addNewStageToProject(this.projectId, stageToSend).subscribe(res => {
            this.isDisabled = false;
            
            this.sections.push(newSection);
            this.ganttService.itemPush(newStage);
            this.originalItems.push(newOriginalStage);
            this.projectStage.push(stageToSend);
            this.stages.push(this.newStageForm.value.name);
            this.modalService.dismissAll();
        }, error => {
            this.isDisabled = false;
            this.feedbackMsg('error', 'Something went wrong');
        });
        this.unsubscribe.push(sub);
    }

    popItem() {
        this.ganttService.itemPop();
    }

    removeItem() {
        this.ganttService.itemRemove(4);
    }

    // setam culoarea progress bar-ului cu due date si span-ul de sub el
    getProgressColor() {
        const start = new Date(this.projectData.startDate);
        const end = new Date(this.projectData.deadline);
        const today = new Date();
        /*        const start = new Date('2022-01-15');
                const today = new Date('2022-02-16');
                const end = new Date('2022-02-28');*/

        const totalDays = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
        const daysElapsed = Math.floor((today.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));

        if (today > end) {
            this.progressBar = 100;
            // 
        } else if (today < start) {
            this.progressBar = 0;
            // 
        } else {
            this.progressBar = Math.floor(100 * daysElapsed / totalDays);
            // 
        }

        if (this.progressBar <= 25) {
            this.barClass = 'bg-success';
            this.spanColor = '#1bc5bd';
        } else if (this.progressBar > 25 && this.progressBar <= 50) {
            this.barClass = 'bg-info';
            this.spanColor = '#8950fc';
        } else if (this.progressBar > 50 && this.progressBar <= 75) {
            this.barClass = 'bg-warning';
            this.spanColor = '#ffa800';
        } else if (this.progressBar > 75 && this.progressBar <= 100) {
            this.barClass = 'bg-danger';
            this.spanColor = '#f64e60';
        }

    }

    getChartOptions() {
        const strokeColor = 'rgba(73, 80, 250, 1)';
        const bgColor = '#ffffff';
        const textColor = '#2E2A41';
        return {
            series: [this.projectCompletion],
            chart: {
                type: 'radialBar',
                height: 200,
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        margin: 0,
                        size: '65%',
                    },
                    dataLabels: {
                        showOn: 'always',
                        name: {
                            show: false,
                            fontWeight: '700',
                        },
                        value: {
                            color: textColor,
                            fontSize: '30px',
                            fontWeight: '700',
                            offsetY: 12,
                            show: true,
                        },
                    },
                    track: {
                        background: bgColor,
                        strokeWidth: '100%',
                        opacity: 1,
                        startAngle: -180,
                        endAngle: 180
                    },
                },
            },
            colors: [strokeColor],
            labels: ['Progress'],
            legend: {},
            dataLabels: {},
            fill: {},
            xaxis: {},
            yaxis: {},
            states: {
                normal: {
                    filter: {
                        type: 'none'
                    }
                },
                hover: {
                    filter: {
                        type: 'none'
                    }
                },
                active: {
                    allowMultipleDataPointsSelection: false,
                    filter: {
                        type: 'none'
                    }
                }
            },
            tooltip: {},
            markers: {},
        };
    }

    openModal(modal) {
        this.loadStageForm();
        this.loadTaskForm();
        
        this.modalService.open(modal, {centered: true});
    }

    addNewMember(user) {
        if (this.teamIds.includes(user.id)) {
            this.feedbackMsg('error', 'This member is already selected');
        } else {
            this.teamIds.push(user.id);
            const sub = this.projectsService.updateProjectStaff(this.projectId, this.teamIds).subscribe((res) => {
                this.teamMembers.push({
                    firstName: user.firstName,
                    lastName: user.lastName,
                    dep: user.department,
                    image: user.profileImagePath,
                    id: user.id
                });
                this.modalService.dismissAll();
            });

            this.unsubscribe.push(sub);
        }
    }

    removeMember(memberId) {
        const index = this.teamIds.indexOf(memberId);
        if (index !== -1) {
            this.teamIds.splice(index, 1);
        }

        const sub = this.projectsService.updateProjectStaff(this.projectId, this.teamIds).subscribe((res) => {
            
            this.teamMembers.splice(index, 1);
        }, error => {
            
        });

        this.unsubscribe.push(sub);
    }

    // Get the project data by id
    getProjectById() {
        const routeSub = this.route.params.subscribe(params => {
            this.projectId = params.id;
            if (this.projectId) {
                this.projectsService.getProjectById(this.projectId).subscribe((project: SingleProjectModel) => {
                    
                    this.projectData = project;
                    this.projectStage = project.stage;
                    if (this.projectStage.length > 0) {
                        this.stagesExist = true;
                    }
                    this.projectStage.forEach(projectStage => {
                        this.stages.push(projectStage.name);
                    });

                    // sort stages
                    // @ts-ignore
                    this.projectStage.sort((a, b) => a.position - b.position);
                    
                    this.projectFiles = project.attachments;
                    this.getProjectCompletion();
                    this.getProjectsTasks();
                    this.getTeamMembersProfile();
                    this.getAllProjectNote();
                    this.getProgressColor();
                    this.loadGanttChart();
                    const start = new Date(this.projectData.startDate);
                    this.startDate = moment([start.getFullYear(), start.getMonth(), start.getDate()]).startOf('day');
                    this.dataLoaded = true;
                });
            } else {
                this.router.navigate(['/contacts/list'], {relativeTo: this.route}).then();
            }
        });
        this.unsubscribe.push(routeSub);
    }

    // Get the percentage of project completion
    getProjectCompletion() {
        const sub = this.projectsService.getProjectCompletion(this.projectId).subscribe((res: any) => {
            if (res.number !== 'NaN') {
                this.projectCompletion = Math.floor(Number(res.number));
            } else {
                this.projectCompletion = 0;
            }
            this.completionLoaded = true;
            this.chartOptions = this.getChartOptions();
        }, error => {
            this.projectCompletion = 6;
        });

        this.unsubscribe.push(sub);
    }

    // Get all project Team Members
    getTeamMembersProfile() {
        const userId = this.projectData.staff;
        userId.forEach((id: any) => {
            const sub = this.projectsService.getUserById(id).subscribe((user: any) => {
                this.teamIds.push(user.id);
                this.teamMembers.push({
                    firstName: user.firstName,
                    lastName: user.lastName,
                    image: user.profileImagePath,
                    dep: user.department,
                    id: user.id
                });
            });
            this.unsubscribe.push(sub);
        });
    }

    // Get Project Notes
    getAllProjectNote() {
        this.projectsService.getAllNotes(this.projectId).subscribe((notes: any) => {
            
            
            this.projectNotes = notes;
        });
    }

    submitStageForm() {
        
        this.newStageForm.markAllAsTouched();
        if (this.newStageForm.valid) {
            this.stagesExist = true;
            this.addItem();
        } else {
            this.feedbackMsg('error', 'Please fill out the required fields.');
        }
    }

    ngAfterViewInit(): void {
        this.dtTrigger.subscribe(() => {
            this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {

                $('#stage').on('change', function() {
                    dtInstance
                        .columns(2)
                        .search('\\b' + this['value'] + '\\b', true, false)
                        .draw();
                });

                $('#tableSearchBox').on('keyup search input paste cut', function() {
                    dtInstance
                        .search(this['value'])
                        .draw();
                });

            });
        });
    }

    toggleFilters() {
        $('#filtersRow').slideToggle();
        this.hideFilters = !this.hideFilters;
    }

    isControlInvalid(controlName: string): boolean {
        const control = this.newStageForm.controls[controlName];
        return control.invalid && (control.dirty || control.touched);
    }


    controlHasError(validation: string, controlName: string) {
        const control = this.newStageForm.controls[controlName];
        return control.hasError(validation) && (control.dirty || control.touched);
    }

    isControlInvalidAlt(controlName: string): boolean {
        const control = this.newTaskForm.controls[controlName];
        return control.invalid && (control.dirty || control.touched);
    }


    controlHasErrorAlt(validation: string, controlName: string) {
        const control = this.newTaskForm.controls[controlName];
        return control.hasError(validation) && (control.dirty || control.touched);
    }

    // FeedBack Msg
    feedbackMsg(type, message) {
        if (type === 'success') {
            this.formSent = true;
            this.formResponse = true;
            this.successMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);

        } else if (type === 'error') {
            this.formSent = true;
            this.formResponse = false;
            this.errorMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);
        }
    }


    ngOnDestroy() {
        this.unsubscribe.forEach(el => el.unsubscribe());
    }

}
